import React from 'react';
import './LoadingLayer.css';

function LoadingLayer(props) {
    return (
            <div className="LoadingLayer"></div>
    );
}

export default LoadingLayer;


// WEBPACK FOOTER //
// ./src/components/LoadingLayer/LoadingLayer.js